var modals = document.querySelectorAll(".modal"),
    spans = document.getElementsByClassName("close");
$(document).ready(function() {
    $("a.modal-button").click(function(e) {
        e.preventDefault(), (modal = document.querySelector(e.target.getAttribute("href"))).style.display = "block"
    })
});
for (var i = 0; i < spans.length; i++) spans[i].onclick = function() {
    for (var e in modals) void 0 !== modals[e].style && (modals[e].style.display = "none")
};
window.onclick = function(e) {
    if (e.target.classList.contains("modal"))
        for (var t in modals) void 0 !== modals[t].style && (modals[t].style.display = "none")
};
/*
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) links[i].hostname === window.location.hostname || "" === links[i].hostname || links[i].classList.contains("today_dd") || (links[i].target = "_blank", links[i].rel = "noreferrer noopener");
*/
$(document).ready(function() {
    $(".read-more-button").click(function() {
        $(".more-txts").toggle(), $(".arrow-btn").toggleClass("arrow-up")
    })
}), $(document).ready(function() {
    $(".forgot_recover").click(function() {
        $(".login-recover").show(), $(".customers-login").hide()
    }), $(".cancel_link").click(function() {
        $(".customers-login").show(), $(".login-recover").hide()
    })
    if(window.location.hash === "#recover") {
        $('.customers-login').hide();
    }
});